import { IDemoState } from "@/store/modules/demo/types";

export const state: IDemoState = {
  sections: [],
  section: null,
  questions: null,
  passages: null,
  completedSections: { ela: {}, math: {}, reading: {} },
};
